<template>
  <div>
    <div class="problem">
      <span>{{ name }}</span>
      <span>{{ type | formatType }}</span>
    </div>
    <div class="options" v-if="options.length > 0">
      <!--
             1-单选 2-多选 3-问答 4.多选混合问答
      -->
      <div v-if="type === '1'">
        <van-radio-group
          v-model="answer.optionId"
          class="option-line"
          @change="checkOptions"
        >
          <div
            v-for="(option, index) in options"
            :key="option.id"
            class="option-item"
          >
            <div class="multiple-input-line">
              <van-radio
                :name="option.id"
                checked-color="#e10913"
              >
                {{ option.name }}
              </van-radio>
              <input
                v-if="isContentType(option, 1)"
                type="text"
                v-model="options[index].optionContent"
                class="multiple-input"
                @click.stop="selectOption(index)"
                @focus="selectOption(index)"
                @input="checkOptions"
              />
            </div>
            <textarea
              v-if="isContentType(option, 2)"
              type="text"
              v-model="options[index].optionContent"
              class="multiple-textarea"
              @click.stop="selectOption(index)"
              @focus="selectOption(index)"
              @input="checkOptions"
            />
          </div>
        </van-radio-group>
      </div>
      <div v-if="type === '2'">
        <van-checkbox-group v-model="answer.optionId" @change="checkOptions">
          <div v-for="option in options" :key="option.id" class="option-line">
            <div class="option-item">
              <div class="multiple-input-line">
                <van-checkbox
                  :name="option.id"
                  checked-color="#e10913"
                  class="square-checkbox"
                >
                  {{ option.name }}
                </van-checkbox>
                <input
                  v-if="isContentType(option, 1)"
                  type="text"
                  v-model="option.optionContent"
                  class="multiple-input"
                  @click.stop="selectOptionByOption(option)"
                  @focus="selectOptionByOption(option)"
                  @input="checkOptions"
                />
              </div>
              <textarea
                v-if="isContentType(option, 2)"
                type="text"
                v-model="option.optionContent"
                class="multiple-textarea"
                @click.stop="selectOptionByOption(option)"
                @focus="selectOptionByOption(option)"
                @input="checkOptions"
              />
            </div>
          </div>
        </van-checkbox-group>
      </div>
      <div v-if="type === '3'">
        <div>
          <input
            v-if="isContentType(options[0], 1)"
            type="text"
            v-model="options[0].optionContent"
            class="multiple-input"
            @input="checkOptions"
          />
          <textarea
            v-if="isContentType(options[0], 2)"
            type="text"
            v-model="options[0].optionContent"
            class="multiple-textarea"
            @input="checkOptions"
          />
        </div>
      </div>
      <div v-if="type === '4'">
        <van-checkbox-group
          v-model="answer.optionId"
          class="option-line"
          @change="checkOptions"
        >
          <div
            v-for="(option, index) in options"
            :key="option.id"
            class="option-item"
          >
            <div class="multiple-input-line">
              <van-checkbox
                :name="option.id"
                checked-color="#e10913"
                ref="checkboxes"
                class="square-checkbox"
              >
                {{ option.name }}
              </van-checkbox>
              <input
                v-if="isContentType(option, 1)"
                type="text"
                v-model="options[index].optionContent"
                class="multiple-input"
                @click.stop="selectOption(index)"
                @focus="selectOption(index)"
                @input="checkOptions"
              />
            </div>
            <textarea
              v-if="isContentType(option, 2)"
              type="text"
              v-model="options[index].optionContent"
              class="multiple-textarea"
              @click.stop="selectOption(index)"
              @focus="selectOption(index)"
              @input="checkOptions"
            />
          </div>
        </van-checkbox-group>
      </div>
    </div>
  </div>
</template>
  <script lang="js">
    export default {
        props:{
            problem: {
                type: Object,
                default: {
                    name: '',
                    options: []
                }
            }
        },
        watch:{
            problem: {
                immediate: true,
                handler(newVal, oldVal){
                    this.initProblem(newVal)
                }
            }
        },
        data(){
            return {
                name: '',
                options: [],    
                type: null,
                answer: {}            
            }
        },
        filters:{
            formatType : function (vaule){
               switch(vaule){
                case '1':
                    return '(单选)'
                case '2':
                    return '(多选)'
                case '3':
                    return '(问答)'       
                case '4':
                    return '(多选)' 
                default:
                    return ''             
               }
            }
        },
        created(){
    
        },
        mounted(){
    
        },
        methods: {
            // 初始化当前题目信息
            initProblem(problem){
                if(!problem){
                    this.name = '';
                    this.options = []
                    this.type = null
                    this.answer = {}
                    return
                }
                this.name = problem.name
                this.options = [...(problem.options || [])]
                this.type = problem.type
                let answer = {...(problem.answer || {})}
                // 预先声明 optionId，保证 Vue2 下 v-model 选中状态响应式生效
                if (answer.optionId === undefined) {
                    answer.optionId = (this.type === '2' || this.type === '4') ? [] : ''
                }
                this.answer = answer
                if(this.type === '3' && this.options.length > 0){
                    this.answer.optionId = this.options[0].id
                    this.checkOptions()
                }
            },
            // 判断选项是否需要填写指定类型的内容
            isContentType(option, type){
                return String(option && option.isContent) === String(type)
            },
            // 同步答案给父组件，并清空未选中选项残留的填写内容
            checkOptions(){
                let selectedIds = Array.isArray(this.answer.optionId)
                    ? this.answer.optionId
                    : (this.answer.optionId ? [this.answer.optionId] : [])
                this.options.forEach(option => {
                    if (option.optionContent && selectedIds.indexOf(option.id) < 0) {
                        option.optionContent = ''
                    }
                })
                let p = {
                    answer: {...this.answer},
                    options: [...this.options]
                }
                this.$emit("change", p)                
            },
            // 选中需要填写内容的选项
            selectOption(index) {
                let option = this.options[index]
                this.selectOptionByOption(option)
            },
            // 根据选项对象更新选中状态
            selectOptionByOption(option) {
                if (!option) {
                    return
                }
                if (this.type === '1') {
                    this.answer.optionId = option.id
                    this.checkOptions()
                    return
                }
                let selectedIds = Array.isArray(this.answer.optionId)
                    ? this.answer.optionId.slice()
                    : []
                if (selectedIds.indexOf(option.id) < 0) {
                    selectedIds.push(option.id)
                    this.answer.optionId = selectedIds
                }
                this.checkOptions()
            },
            toggle(index) {
                let current = this.options[index].id;
                if(Array.isArray(this.answer.optionId) && this.answer.optionId.some(o => o === current)){
                    //已勾选 需点击checkbox 反选
                    return;
                }
                this.$refs.checkboxes[index].toggle();
            },
        }
    }
  </script>    
  <style scoped lang="less" rel="stylesheet/less">
.problem {
  font-size: 18px;
}
.options {
  font-size: 16px;
  max-height: calc(100vh - 3.6rem - 110px);
  overflow: auto;
}
.option-line {
  display: flex;
  flex-direction: column;
}
.multiple-input-line {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
}
.multiple-input-line .multiple-input {
  flex: 1;
  min-width: 0;
  box-sizing: border-box;
  padding-left: 0.22rem;
}
.option-item {
  margin: 0.2rem 0.2rem;
}
.multiple-input-line .van-radio,
.multiple-input-line .van-checkbox {
  display: flex;
  align-items: flex-start;
  min-width: 0;
  max-width: 100%;
  line-height: 24px;
}
.multiple-input-line .van-radio /deep/ .van-radio__icon,
.multiple-input-line .van-checkbox /deep/ .van-checkbox__icon {
  flex: none;
  margin-top: 2px;
}
.multiple-input-line .van-radio /deep/ .van-radio__label,
.multiple-input-line .van-checkbox /deep/ .van-checkbox__label {
  flex: 1;
  min-width: 0;
  white-space: normal;
  word-break: break-all;
  line-height: 24px;
}
.van-radio /deep/ .van-radio__icon .van-icon,
.van-checkbox /deep/ .van-checkbox__icon .van-icon {
  border-color: #666;
}
.square-checkbox /deep/ .van-checkbox__icon .van-icon {
  border-radius: 2px;
}
.multiple-input {
  background: #f6f6f6;
  border-top: none;
  border-left: none;
  border-right: none;
  width: auto;
  border-width: 1px;
}
.multiple-textarea {
  background: #f6f6f6;
  margin-top: 0.2rem;
  margin-left: 0.2rem;
  width: 7.5rem;
  height: 2rem;
}
</style>
    


// WEBPACK FOOTER //
// src/components/client/childCompoents/surveyProblem.vue